<template>
<div>
    <div class="modal fade" id="retirarModalToggle" aria-hidden="true" aria-labelledby="retirarModalToggleLabel"
        tabindex="-1" data-bs-backdrop="false" style="background-color:rgba(0, 0, 0, 0.5);">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content" :style="skin.my_account.main_background">
                <div class="modal-header" style="border-bottom: none;">
                    <h5>{{ translate('Solicitud para Retirar') }}</h5>
                    <button :style="skin.my_account.close_btn" style="background: none;" type="button" class="btn-close"
                        data-bs-dismiss="modal" aria-label="Close"><i class="fas fa-times"></i></button>
                </div>
                <div class="modal-body">
                    <div>
                        <div v-if="status.result != 'OK'" class="alert alert-danger" role="alert">
                            {{ status.msg }}
                        </div>
                        <form @submit.prevent="retiro()">
                            <div v-if="skin.register_fields.name" class="mb-3">
                                <label for="retirarname">{{ translate('Nombre del Titular') }}</label>
                                <input v-model="datos_retirar.name" type="text" id="retirarname" class="form-control"
                                    :placeholder="translate('Nombre del Titular de la cuenta')"
                                    aria-label="retirarname" aria-describedby="retirarname"
                                    :readonly="skin.register_fields.cpf_verification">
                            </div>
                            <div v-if="skin.register_fields.name" class="mb-3">
                                <label for="retirarbanco">{{ translate('Banco') }}</label>
                                <input v-model="datos_retirar.banco" type="text" id="retirarbanco" class="form-control"
                                    :placeholder="translate('Ingrese el Banco')" aria-label="retirarbanco"
                                    aria-describedby="retirarbanco" :readonly="skin.register_fields.cpf_verification">
                            </div>
                            <div v-if="skin.register_fields.name" class="mb-3">
                                <label for="retirartipocuenta">{{ translate('Tipo de Cuenta') }}</label>
                                <input v-model="datos_retirar.tipo_cuenta" type="text" id="retirartipocuenta"
                                    class="form-control" :placeholder="translate('Ingrese el tipo de Cuenta')"
                                    aria-label="retirartipocuenta" aria-describedby="retirartipocuenta"
                                    :readonly="skin.register_fields.cpf_verification">
                            </div>
                            <div v-if="skin.register_fields.idn" class="mb-3">
                                <label for="retirocuenta">{{ translate('Cuenta') }}</label>
                                <input v-model="datos_retirar.cuenta" type="number" id="retirocuenta"
                                    class="form-control" placeholder="Numero de cuenta" aria-label="retirocuenta"
                                    aria-describedby="retirocuenta">
                            </div>
                            <div class="mb-3">
                                <label for="retiro">{{ translate('valor de Retiro') }}</label>
                                <input v-model="datos_retirar.valor" type="number" id="retiro" class="form-control"
                                    placeholder="Ingrese el valor de retiro" aria-label="retiro"
                                    aria-describedby="retiro">
                            </div>
                            <div v-if="skin.register_fields.country" class="mb-3">
                                <label for="retiroCountry">{{ translate('country') }}</label>
                                <select class="form-control" name="country" v-model="datos_retirar.country"
                                    id="retiroCountry" required>
                                    <option v-for="(country, index) in countries()" :key="index" :value="country.code">
                                        {{ language == "es" ? country.name_es :
                                            country.name_en }}
                                    </option>
                                </select>
                            </div>
                            <div class="text-center">
                                <span v-if="register_inProcess" class="spinner-border" :style="skin.loader"
                                    role="status">
                                    <span class="visually-hidden">Loading...</span>
                                </span>
                            </div>
                            <button type="submit" :style="skin.qbet.confirm_btn" class="p-2 text-center mb-2"
                                style="width:100%;color:white" :disabled="register_inProcess">{{
                                    translate('confirm') }}</button>
                            <button :style="skin.qbet.booking_btn" class="btn btn-primary" style="width:100%;"
                                data-bs-target="" data-bs-toggle="modal" data-bs-dismiss="modal">{{
                                    translate('back') }}</button>
                        </form>
                        <button data-bs-target="#retirarModalToggle3" data-bs-toggle="modal" data-bs-dismiss="modal"
                            style="display:none;" id="registerSuccessfull"></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="retirarModalToggle3" aria-hidden="true" aria-labelledby="retirarModalToggleLabel3"
        tabindex="-1" data-bs-backdrop="false" style="background-color:rgba(0, 0, 0, 0.5);">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content" :style="skin.my_account.main_background">
                <div class="modal-header" style="border-bottom: none;">
                    <button :style="skin.my_account.close_btn" style="background: none;" type="button" class="btn-close"
                        data-bs-dismiss="modal" aria-label="Close"><i class="fas fa-times"></i></button>
                </div>
                <div class="modal-body">
                    <div class="text-center p-2">
                        <span style="font-size:64px;color:green;"><i class="fas fa-check-circle"></i></span><br>
                        <!-- <span>{{ translate('Solicitud de retiro Aprobado') }}</span><br>
                        <span>{{ translate('Mira el historial retiros') }}</span> -->
                        <span>{{translate('register_success')}}</span><br>
                        <span>{{translate('can_login')}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
    
</template>
<script>
const countries = require('../../../assets/countries.json');
import axios from 'axios';
export default {
    name: "register",
    props: ['skin', 'translation', 'language'],
    data() {
        return {
            status: { result: "OK", msg: "" },
            agreement: false,
            register_inProcess: false,
            datos_retirar: {
                name: "",
                banco: "",
                tipo_cuenta: "",
                cuenta: "",
                valor: "",
                country: "",
            }
        }
    },
    computed: {
        user() {
            let data = this.$store.getters['getUserData'];
            return data;
        },
        root() {
            let data = this.$store.getters['getRoot'];
            return data;
        },
        apiUrlnew() {
            return this.$store.getters['getApiUrlnew'];
        },
    },
    methods: {
        async retiro() {
            this.register_inProcess = true;
            try {
                const allFieldsFilled = Object.values(this.datos_retirar).every(value => value.trim() !== "");
                if (!allFieldsFilled) {
                    this.status.result = 'error';
                    this.status.msg = "Debes completar los datos";
                    this.register_inProcess = false;
                } else if (this.user.user_data.data.balance < this.datos_retirar.valor) {
                    this.register_inProcess = false;
                    this.status.result = 'error';
                    this.status.msg = "No se puede retirar más de lo que tienes";
                }
                else {
                    const fechaActual = new Date();
                    const fecha = `${fechaActual.getFullYear()}-${String(fechaActual.getMonth() + 1).padStart(2, '0')}-${String(fechaActual.getDate()).padStart(2, '0')}`;
                    const hora = `${String(fechaActual.getHours()).padStart(2, '0')}:${String(fechaActual.getMinutes()).padStart(2, '0')}:${String(fechaActual.getSeconds()).padStart(2, '0')}`;
                    let data = {
                        id: this.user.user_data.data.user_id,
                        name: this.user.user_data.data.user_name,
                        descripcion: {
                            name: this.datos_retirar.name,
                            banco: this.datos_retirar.banco,
                            tipo_cuenta: this.datos_retirar.tipo_cuenta,
                            cuenta: this.datos_retirar.cuenta,
                            country: this.datos_retirar.country
                        },
                        fecha: `${fecha} ${hora}`,
                        puntos: 0,
                        valor: this.datos_retirar.valor,
                        estado: 0,
                        login_Id: this.root.id,
                        token: this.user.token
                    };
                    console.log(data);
                    let response = await axios.post(this.apiUrlnew + "solicitud", data);
                    if (response.data.error) {
                        this.new_user_data.error = response.data.error;
                        this.register_inProcess = false;
                        this.status.result = 'error';
                        this.status.msg = "Hubo un problema al procesar tu solicitud.";
                    } else {
                        this.status.result = 'success';
                        this.status.msg = "¡Solicitud enviada exitosamente!";
                        document.getElementById('registerSuccessfull').click();
                    }
                    this.register_inProcess = false;
                }
            } catch (error) {
                console.log(error);
                this.register_inProcess = false;
            }
        },
        countries() {
            let country_list = [];
            countries.countries.forEach(country => {
                country_list.push(country);
            })
            return country_list.sort((a, b) => (a[this.$props.language == "es" ? "name_es" : "name_en"] > b[this.$props.language == "es" ? "name_es" : "name_en"]) ? 1 : -1)
        },
        translate(text) {
            if (text) {
                if (this.$props.translation[text]) {
                    return this.$props.translation[text][this.$props.language];
                }
                else {
                    var new_text_serched = text.replace(/ /g, "_");
                    if (this.$props.translation[new_text_serched]) {
                        return this.$props.translation[new_text_serched][this.$props.language];
                    }
                }
                return text;
            }
        },
    },
    
}
</script>

<style>
input[type="file"] {
    padding: 10px;
    border-radius: 5px;
    border: 1px solid #ccc;
    transition: border-color 0.3s;
}

input[type="file"]:focus {
    border-color: #007bff;
    /* Color de Bootstrap para el foco */
}

.form-text {
    margin-top: 5px;
    /* Espaciado adicional para el texto de ayuda */
}
</style>